import { Icons } from "@/components/ui/icons";
import { cn } from "@/lib/cn";

interface SpinnerProps {
  /** Size class override. Default: "h-5 w-5". */
  className?: string;
  "data-testid"?: string;
}

export function Spinner({ className, "data-testid": testId }: SpinnerProps) {
  return (
    <Icons.Spinner
      className={cn("h-5 w-5 animate-spin text-accent", className)}
      data-testid={testId}
      aria-hidden="true"
    />
  );
}
